import { Outlet, Link } from "react-router-dom";
import { Navbar } from "./Navbar";
import { CookieConsent } from "./CookieConsent";
import { AuthModal } from "./AuthModal";
import { useTheme } from "@/src/lib/useTheme";

export function Layout() {
  const { theme } = useTheme();

  return (
    <div className={`min-h-screen flex flex-col font-sans selection:bg-emerald-500/30 transition-colors duration-300 ${theme === 'dark' ? 'bg-[#050505] text-neutral-50' : 'bg-[#f8fafb] text-neutral-900'}`}>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-emerald-600 focus:text-white focus:rounded">Skip to content</a>
      <Navbar />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-neutral-200 dark:border-white/10 bg-white dark:bg-neutral-950">
        <nav aria-label="Footer navigation">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
            {/* Brand */}
            <div className="md:col-span-1">
              <Link to="/" className="text-xl font-light tracking-wide">
                p<span className="text-emerald-500">α</span>rb<span className="text-emerald-500">ε</span>rkon
              </Link>
              <p className="text-neutral-400 dark:text-white/40 text-xs mt-1 uppercase tracking-[0.2em]">
                cyprus barbershop directory
              </p>
              <p className="text-neutral-500 dark:text-white/50 text-sm mt-3 leading-relaxed">
                Cyprus' #1 barbershop directory. Find the best barbers near you across all major cities.
              </p>
            </div>
            {/* Cities */}
            <div>
              <h4 className="font-semibold text-neutral-700 dark:text-white/80 mb-3 text-sm uppercase tracking-wider">Top Cities</h4>
              <ul className="space-y-2 text-sm text-neutral-500 dark:text-white/50">
                <li><Link to="/cities/limassol" className="hover:text-emerald-400 transition-colors">Limassol</Link></li>
                <li><Link to="/cities/nicosia" className="hover:text-emerald-400 transition-colors">Nicosia</Link></li>
                <li><Link to="/cities/paphos" className="hover:text-emerald-400 transition-colors">Paphos</Link></li>
                <li><Link to="/cities/larnaca" className="hover:text-emerald-400 transition-colors">Larnaca</Link></li>
                <li><Link to="/cities/famagusta" className="hover:text-emerald-400 transition-colors">Famagusta</Link></li>
              </ul>
            </div>
            {/* Directory */}
            <div>
              <h4 className="font-semibold text-neutral-700 dark:text-white/80 mb-3 text-sm uppercase tracking-wider">Directory</h4>
              <ul className="space-y-2 text-sm text-neutral-500 dark:text-white/50">
                <li><Link to="/" className="hover:text-emerald-400 transition-colors">All Shops</Link></li>
                <li><Link to="/leaderboard" className="hover:text-emerald-400 transition-colors">Leaderboard</Link></li>
                <li><Link to="/profile" className="hover:text-emerald-400 transition-colors">My Profile</Link></li>
              </ul>
            </div>
            {/* Info & Legal */}
            <div>
              <h4 className="font-semibold text-neutral-700 dark:text-white/80 mb-3 text-sm uppercase tracking-wider">Legal &amp; Company</h4>
              <ul className="space-y-2 text-sm text-neutral-500 dark:text-white/50">
                <li><Link to="/terms-of-service" className="hover:text-emerald-400 transition-colors">Terms of Service</Link></li>
                <li><Link to="/privacy-policy" className="hover:text-emerald-400 transition-colors">Privacy Policy</Link></li>
                <li><Link to="/cookie-policy" className="hover:text-emerald-400 transition-colors">Cookie Policy</Link></li>
                <li><Link to="/disclaimer" className="hover:text-emerald-400 transition-colors">Listing Disclaimer &amp; Liability</Link></li>
                <li><Link to="/company-info" className="hover:text-emerald-400 transition-colors">Company Info &amp; Disclosures</Link></li>
                <li><Link to="/contact" className="hover:text-emerald-400 transition-colors">Contact Us</Link></li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-neutral-200 dark:border-white/10 pt-4 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-neutral-400 dark:text-white/40 text-sm">&copy; {new Date().getFullYear()} pαrbεrkon (Zebeh). All rights reserved.</p>
            <div className="flex items-center gap-2">
              <span className="text-amber-400/90 text-sm">Operated by</span>
              <a
                href="https://zebeh.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-4 py-1.5 rounded-full text-sm font-semibold text-white bg-gradient-to-r from-pink-500 via-rose-500 to-amber-400 hover:opacity-90 transition-opacity"
              >
                zebeh.com
              </a>
            </div>
          </div>
        </div>
        </nav>
      </footer>
      <CookieConsent />
      <AuthModal />
    </div>
  );
}
